import { render, staticRenderFns } from "./zone.vue?vue&type=template&id=140fd852&scoped=true&"
import script from "./zone.vue?vue&type=script&lang=js&"
export * from "./zone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140fd852",
  null
  
)

export default component.exports